import ComoObtenerlo from './ComoObtenerlo';
export default ComoObtenerlo;
